const APP_DATA_API_URL = process.env.REACT_APP_DATA_API_URL;
export default APP_DATA_API_URL;
